
import { defineComponent, reactive, toRefs, ref } from "vue";
import { userStore } from "@/store/index";
import { BaiduMap, BmMarker, BmLabel } from "baidu-map-vue3";
export default defineComponent({
  name: "aboutUs",
  components: { BaiduMap, BmMarker, BmLabel },
  props: ["companyProfile", "connectUs"],
  setup() {
    const store = userStore();
    const data = reactive({
      cmsDetail: store.cmsDetail,
      svgList: [
        { svgName: "youxiang", name: "电子邮箱", content: store.cmsDetail.cmsEmail },
        { svgName: "dianhua", name: "联系电话", content: store.cmsDetail },
        { svgName: "ditu", name: "联系地址", content: store.cmsDetail }
      ]
    });

    const styles = ref({
      fontSize: "16px",
      border: "none",
      height: "40px",
      lineHeight: "40px"
    });
    const point = ref({
      lng: 108.953501,
      lat: 34.214317
    });
    const jump = (url: string) => {
      const aaa = document.getElementById(url);
      if (aaa) {
        aaa.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    };
    return {
      ...toRefs(data),
      jump,
      point,
      styles
    };
  }
});
